module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../../node_modules/babel-loader/lib/index.js!./AirwallexSelfHostedPage.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/Checkout/ShippingAndPayment/AirwallexSelfHostedPage.js
// module id = 1174
// module chunks = 58